var map = {
	"./001.png": "XXmA",
	"./1-1.png": "7xp4",
	"./1-2.png": "agus",
	"./1-3.png": "PWWJ",
	"./1-4.png": "5lvS",
	"./1-5.png": "Ur9o",
	"./1层.png": "mEHv",
	"./2-1.png": "u/Jp",
	"./2-10.png": "PgC9",
	"./2-2.png": "+sL9",
	"./2-3.png": "6aG6",
	"./2-4.png": "SQKg",
	"./2-5.png": "5PjZ",
	"./2-6.png": "69Qu",
	"./2-7.png": "xKZV",
	"./2-8.png": "5qN5",
	"./2-9.png": "048F",
	"./21层.png": "K/8i",
	"./2层(1).png": "3cPv",
	"./2层.png": "LVAG",
	"./3-1.png": "cNYH",
	"./3-2.png": "kXOK",
	"./3-3.png": "CHg6",
	"./3-4.png": "1Kas",
	"./3-5.png": "s013",
	"./3-6.png": "bEAL",
	"./3-7.png": "q0v7",
	"./3-8.png": "YwQ2",
	"./3层.png": "fpGl",
	"./4-1.png": "4lQY",
	"./4-2.png": "5IMn",
	"./4-3.png": "IoG2",
	"./4-4.png": "zsTY",
	"./4层.png": "YGoN",
	"./LOGO.png": "P81Z",
	"./TOP.png": "gbB8",
	"./TOP@2x.png": "n1FK",
	"./dark.svg": "iDVA",
	"./light.svg": "dAcB",
	"./login-background.jpg": "M+SN",
	"./logo1.png": "jquh",
	"./logo2.png": "n9aG",
	"./logo3.png": "JGOo",
	"./pay.png": "5os5",
	"./profile.jpg": "AY2A",
	"./tabs2.png": "AcFZ",
	"./tbas1.png": "kT8K",
	"./top1.png": "MWYe",
	"./三层(1).png": "Oy3m",
	"./三层.png": "kGoc",
	"./三角顶.png": "gCMr",
	"./个人数字业务.png": "/sj5",
	"./产业数字化.png": "CV+9",
	"./企业数字业务.png": "HVOP",
	"./侧边栏.png": "oVI8",
	"./侧边栏1.png": "lL/Q",
	"./四层(1).png": "5+ea",
	"./四层.png": "hLmJ",
	"./图标.png": "4dbc",
	"./圆角矩形1.png": "+YrO",
	"./多边形.png": "E1sB",
	"./引线红.png": "M/AR",
	"./引线绿.png": "rWln",
	"./引线蓝.png": "pFGe",
	"./总标题.png": "8w3n",
	"./数字产业化.png": "8do2",
	"./数字价值化.png": "YN20",
	"./数字化治理.png": "ZtdE",
	"./数据价值化.png": "U487",
	"./暗纹.png": "+iNs",
	"./标签宏观调控.png": "IDKn",
	"./标签数字安全.png": "D1a+",
	"./标签数字政务.png": "zqDV",
	"./标签碳金融.png": "RX3V",
	"./标签金融治理.png": "8t6G",
	"./标题.png": "Uw3O",
	"./背景.png": "nRQr",
	"./虚线红.png": "4ydN",
	"./虚线绿.png": "qvxa",
	"./详情.png": "jekh"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "WHhX";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics ^\.\/.*$
// module id = WHhX
// module chunks = 0